import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiDropdown, TuiButton } from '@taiga-ui/core';

import { EmojiModule } from '../emoji';

import { ReactionListComponent } from './reaction-list';
import { ReactionSelectionComponent } from './reaction-selection';

@NgModule({
  declarations: [ReactionListComponent, ReactionSelectionComponent],
  imports: [CommonModule, TuiButton, EmojiModule, ...TuiDropdown],
  exports: [ReactionListComponent, ReactionSelectionComponent],
})
export class ReactionModule {}
